import React from "react";

/**
 * Compact inline benchmark pill for the Leads table cell.
 *   State A — match_count >= config_threshold: "Yth pct"
 *   State B — 1 <= match_count < threshold: "—"
 *   State C — match_count == 0: renders nothing
 */
function ordinal(n) {
  const i = Math.round(n);
  const v = i % 100;
  if (v >= 11 && v <= 13) return `${i}th`;
  switch (i % 10) {
    case 1: return `${i}st`;
    case 2: return `${i}nd`;
    case 3: return `${i}rd`;
    default: return `${i}th`;
  }
}

export default function CompactBenchmarkPill({ data, testId }) {
  if (!data) return null;
  const { match_count, percentile, config_threshold } = data;

  if (match_count === 0) return null;

  if (match_count < config_threshold) {
    return (
      <span
        className="inline-flex items-center text-[10px] text-muted-foreground"
        title="Benchmark dataset is growing"
        data-testid={testId ? `${testId}-growing` : undefined}
      >
        —
      </span>
    );
  }

  if (percentile == null) return null;

  return (
    <span
      className="inline-flex items-center px-1.5 py-0.5 rounded-full bg-accent/15 border border-accent/30 text-[10px] font-medium text-accent"
      title={`${ordinal(percentile)} percentile among ${match_count} comparable Discoveries`}
      data-testid={testId ? `${testId}-pct` : undefined}
    >
      {ordinal(percentile)} pct
    </span>
  );
}
